<ng-template #assetListTemplateRef>
  @if (mpStore?.isAssetListVisibleSignal()) {
    <subsection-preview-asset-list [activeFile]="item" (fileClick)="handleAssetClick()">
    </subsection-preview-asset-list>
  }
</ng-template>

<ng-template #assetInfoTemplateRef>
  <mtm-asset-info [file]="item" [visible]="isAssetInfoVisible"> </mtm-asset-info>
</ng-template>

@if (item?.status !== 'uploading' && item?.malwareScanningStatus !== MalwareScanningStatus.Clean) {
  <mtm-asset-scan-info [file]="item" (scanFinished)="handleScanStatusChange()"> </mtm-asset-scan-info>
}

<div
  class="media-player-container d-flex flex-column"
  [class.fullscreen]="mpStore?.isFullscreenSignal()"
  [class.old-item]="mpStore?.oldItemSignal() && !ignoreOldItem"
  [class.h-100]="mpStore?.isLoadingOrBeingTranscoded()">
  @if (item?.status === 'uploading') {
    <upload-progress-viewer #uploadProgressViewer [file]="item"></upload-progress-viewer>
  }
  @if (item?.status !== 'uploading' && item?.malwareScanningStatus === MalwareScanningStatus.Clean) {
    <div class="d-block">
      @if (showCloseButton) {
        <div class="file-close-btn d-flex justify-content-between pb-3">
          <span class="text-white f-12 p-1">{{ item?.displayName || '' }}</span>
          <button type="button" (click)="activeModal.close()" class="btn btn-sm btn-danger f-12"> Close</button>
        </div>
      }

      @if (mpStore?.mediaTypeSignal() === MediaType.VIDEO) {
        <video-viewer
          #videoViewer
          [instanceId]="instanceId"
          [width]="width"
          [height]="height"
          [miniPlayer]="miniPlayer"
          [autoPlayVideo]="autoPlayVideo"
          [videoPreloadMethod]="videoPreloadMethod"
          [previewContainerHeight]="previewContainerHeight"
          [assetListTemplate]="assetListTemplateRef"
          [assetInfoTemplate]="assetInfoTemplateRef"></video-viewer>
      }
      @if (mpStore?.mediaTypeSignal() === MediaType.AUDIO) {
        <audio-viewer
          #audioViewer
          [instanceId]="instanceId"
          [audioPreloadMethod]="audioPreloadMethod"
          [assetListTemplate]="assetListTemplateRef"
          [assetInfoTemplate]="assetInfoTemplateRef"></audio-viewer>
      }
      @if ([MediaType.IMAGE, MediaType.CONVERTIBLEIMAGE].includes(mpStore?.mediaTypeSignal())) {
        <image-viewer
          #imageViewer
          [instanceId]="instanceId"
          [mode]="mode"
          [isKpfPreview]="isKpfPreview"
          [assetListTemplate]="assetListTemplateRef"
          [assetInfoTemplate]="assetInfoTemplateRef"></image-viewer>
      }
      @if ([MediaType.PDF, MediaType.OFFICEDOC, MediaType.POWERPOINT].includes(mpStore?.mediaTypeSignal())) {
        <pdf-viewer
          #pdfViewer
          [instanceId]="instanceId"
          [enablePage]="enablePage"
          [assetListTemplate]="assetListTemplateRef"
          [assetInfoTemplate]="assetInfoTemplateRef"></pdf-viewer>
      }

      <!-- Not Supported File -->
      @if (mpStore?.isFileNotSupportedSignal()) {
        <div class="download-link not-supported-container w-100 h-100 min-h-250">
          @if (enableAnnotation) {
            <old-mtm-comment-annotation
              class=""
              [annotations]="mpStore?.annotationsSignal()"
              [item]="item"
              [projectId]="mpStore?.projectIdSignal()"
              [sectionId]="mpStore?.sectionIdSignal()"
              [subsectionId]="mpStore?.subsectionIdSignal()"
              [instanceId]="instanceId"
              [hideAnnotationToolbar]="mpStore?.hideAnnotationToolbarSignal()">
            </old-mtm-comment-annotation>
          }

          <div
            class="content-container position-relative asset-container w-100 h-100 d-flex flex-column align-items-center justify-content-center py-4">
            <ng-container [ngTemplateOutlet]="assetListTemplateRef"></ng-container>
            <ng-container [ngTemplateOutlet]="assetInfoTemplateRef"></ng-container>

            <img
              class="d-block mx-auto mb-3"
              src="/assets/img/versioning/unknown-file.svg"
              alt="unknown file"
              width="36"
              height="46" />

            <div
              class="not-supported-title text-uppercase mb-3"
              [innerHTML]="'mediaPlayer_notSupported_title' | translate: displayInfo">
            </div>
            <div class="not-supported-desc text-center mb-3">
              <span class="d-block">{{ 'mediaPlayer_notSupported_desc1' | translate }}</span>
              <span class="d-block mb-3">{{ 'mediaPlayer_notSupported_desc2' | translate }}</span>
              <span class="d-block">{{ 'mediaPlayer_notSupported_desc3' | translate }}</span>
            </div>

            @if (showDownloadButtonIfNotPreviewAble) {
              <mtm-file-download-control
                [file]="item"
                [displayType]="'unknown-download'"
                [uniqueControlId]="`media-player-download-not-exists${item?.projectId}-${item?.sectionId}-${item?.subSectionId}-${item?.id}`">
              </mtm-file-download-control>
            }
          </div>
        </div>
      }
    </div>
  }
</div>
